import React from 'react';
import PropTypes from 'prop-types';
import GalleryGrid from '../../../../../core/components/GalleryGrid';
import Image from '../../../../../core/components/Uploaders/Image';
const ImageContentList = ({ items, onRemove }) => {
    return (React.createElement(GalleryGrid, { items: items }, (post) => { var _a; return React.createElement(Image, { fileId: (_a = post === null || post === void 0 ? void 0 : post.data) === null || _a === void 0 ? void 0 : _a.fileId, onRemove: () => onRemove(post.postId) }); }));
};
ImageContentList.propTypes = {
    items: PropTypes.array,
    onRemove: PropTypes.func,
};
ImageContentList.defaultProps = {
    items: [],
    onRemove: () => { },
};
export default ImageContentList;
//# sourceMappingURL=image.js.map